import { useMemo } from "react";
import {
  Svg,
  Circle,
  Pos,
  Lab,
  Outer,
  Text1,
  Text2,
  CircleGroup,
  LabContainer,
} from "./Overview.label.style";

import { useLocation } from "react-router-dom";
import { active_project } from "state/store.global";
import { useClick } from "./Overview.label.click";
import { _project } from "state/store.projects";
import { getFocus, useGet } from "state/jotai";
import { useBreak } from "hooks/useBreak";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import { useLabelData } from "hooks/useLabelData";
import { useTransformComponent } from "react-zoom-pan-pinch";


dayjs.extend(customParseFormat);

export const Label = ({
  c,
  sc,
  d,
  l,
  rmode,
  labelsInfo,
  showLabel,
  hoveredId,
}) => {
  // const [scale, setScale] = useState(1)
  const isMobile = useBreak("md_dn");
  const allUnits = getFocus(_project, "units");
  const options = getFocus(_project, "filteroptions");
  const { pin, pid } = useGet(active_project);
  const click = useClick();
  const here = useLocation().pathname.split("/");

  const isOverview = here.at(-1) === "isometry";
  const isHovered = hoveredId === labelsInfo?.URLSafe;

  const buttonsLabel = getFocus(_project, "buttonsLabel")?.[pin]?.[pid] ?? [];


  const PIN = labelsInfo?.PIN;
  const PID = labelsInfo?.PID;

  const units = allUnits?.[PIN]?.[PID]?.Units ?? [];

  const {
    totalUnits,
    rMinSize,
    rMaxSize,
    noRmin,
    noRmax,
    finalMdate,
    saletype,
  } = useLabelData({ units, PID });
  const getLabel = (key) =>
    buttonsLabel.find((b) => b.UILabelProperty === key)?.Label;

  const scale = useTransformComponent((s) => s.state.scale)

  if (!(isOverview && !rmode)) return null;

  return (
    <Pos c={c} style={{ zIndex: isHovered ? 10 : 5 }}>
      <div style={{    transform: `scale(${1 / scale}) translateZ(0)`,
    transformOrigin: 'center',
    WebkitBackfaceVisibility: 'hidden',
    backfaceVisibility: 'hidden',
    WebkitFontSmoothing: 'antialiased', }}>
        <Svg viewBox="0 0 100 100">
          <CircleGroup>
            <Circle  clr={clr} cx={50} cy={50} r={15} />
            <Circle  clr={clr} cx={50} cy={50} r={25} fillOpacity="0.5" />
            <Circle  clr={clr} cx={50} cy={50} r={35} fillOpacity="0.3" />
          </CircleGroup>
        </Svg>

        {isHovered && showLabel ? (
          <Outer d={d} l={l} xAxis={0} yAxis={-118}>
            <LabContainer
              d={d}
              l={l}
              clr={clr}
              onClick={!isMobile ? () => click(labelsInfo) : undefined}
            >
              <Text2 style={{ borderBottom: "2px solid #fff", padding: 8 }}>
                Boliger til {saletype}
              </Text2>

              <Lab clr={clr}>
                <Text1>{labelsInfo?.Presentation}</Text1>

                {
                  !!totalUnits && 
                  <Text2>
                        {totalUnits}{" "}
                        {(totalUnits > 1
                          ? getLabel("boliger")
                          : getLabel("bolig")
                        )?.toLowerCase()}
                  </Text2>
                }
                { !!labelsInfo?.available_Units &&
                  <Text2>
                    {labelsInfo?.available_Units}{" "}
                    {labelsInfo?.available_Units > 1
                      ? getLabel("Ledige")
                      : "ledig"}
                  </Text2>
                  }

                {!!rMaxSize && (
                  <Text2>
                    {rMinSize} - {rMaxSize}{" "}
                    {options?.[PIN]?.[PID]?.find(p => p.Label === "Størrelse")?.Postfix}
                  </Text2>
                )}

                {!!noRmax && (
                  <Text2>
                    {noRmin} - {noRmax}{" "}
                    {noRmax > 1
                      ? getLabel("værelser")?.toLowerCase()
                      : getLabel("værelse")?.toLowerCase()}
                  </Text2>
                )}

                {finalMdate && (
                  <Text2>
                    {getLabel("Indflytning")}: {finalMdate}
                  </Text2>
                )}
              </Lab>
            </LabContainer>
          </Outer>
        ) : (
          <Outer d={d} l={l} xAxis={0} yAxis={-50}>
            <LabContainer
              d={d}
              l={l}
              clr={clr}
              onClick={!isMobile ? () => click(labelsInfo) : undefined}
            >
              <Text2 style={{ padding: 8 }}>
                Boliger til {saletype}
              </Text2>
            </LabContainer>
          </Outer>
        )}
      </div>
    </Pos>
  );
};